import React from "react";

const Bigtext = ( {data} ) => {
    return(
        <div className="flex flex-col font-medium lg:text-[56px] md:text-[40px] text-[28px]">
            {
                data.bigtext.map( (bigtext, index) =>(
                    <span key={index} className="text-pretty leading-tight" style={{color: bigtext.text_color}}>{bigtext.text}</span>
                ))
            }
        </div>
        
    );
};
export default Bigtext;